import { render, staticRenderFns } from "./InvalidStep.vue?vue&type=template&id=6005529a&scoped=true&lang=html&"
import script from "./InvalidStep.vue?vue&type=script&lang=js&"
export * from "./InvalidStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005529a",
  null
  
)

export default component.exports